import { render } from "./ExaminationComponent.vue?vue&type=template&id=58e52448"
import script from "./ExaminationComponent.vue?vue&type=script&lang=js"
export * from "./ExaminationComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__